module.exports = __webpack_public_path__ + "static/fonts/BMYEONSUNG_ttf.ttf?30f546f7";